import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'

import { dv360TargetingSelector } from '../../../../../../../../modules/selectors/dv360Constants'

import { targetingTypes } from '../../../../../LineItemDv360Create/fields'

import useDrawerFormStyles from '../../../../../../../../styles/common/drawerForms'
import useStyles from './styles'

const ManuallyEnteredKeywordsSectionPreview = () => {
  const { t } = useTranslation()

  const drawerFormClasses = useDrawerFormStyles()
  const classes = useStyles()

  const targeting = useSelector(dv360TargetingSelector)

  const keywordsNames = useMemo(() => {
    return targeting
      .filter(option => option.type === targetingTypes.TARGETING_TYPE_KEYWORD && !option.negative)
      .map(option => option.keyword)
  }, [targeting])

  const excludedKeywordsNames = useMemo(() => {
    return targeting
      .filter(option => option.type === targetingTypes.TARGETING_TYPE_KEYWORD && option.negative)
      .map(option => option.keyword)
  }, [targeting])

  return (
    <section className={classnames(drawerFormClasses.section, classes.keywordsSection)}>
      {keywordsNames.length > 0 && (
        <>
          <h3 className={drawerFormClasses.sectionTitle}>{t('Keywords')}</h3>
          {keywordsNames.map(keywordName => (
            <p>{keywordName}</p>
          ))}
        </>
      )}

      {excludedKeywordsNames.length > 0 && (
        <>
          <h3 className={classnames(drawerFormClasses.sectionTitle, classes.excludeKeywordsTitle)}>
            {t('Excluded keywords')}
          </h3>
          {excludedKeywordsNames.map(keywordName => (
            <p>{keywordName}</p>
          ))}
        </>
      )}
    </section>
  )
}

export default ManuallyEnteredKeywordsSectionPreview
